import classNames from 'classnames';
import { useEffect } from 'react';

import Page from './components/Page';
import Aside from './parts/Aside';
import SectionEducation from './parts/SectionEducation';
import SectionExpPage1 from './parts/SectionExp/SectionExpPage1';
import SectionExpPage2 from './parts/SectionExp/SectionExpPage2';
import SectionExpPageRest from './parts/SectionExp/SectionExpPageRest';
import SectionProjects from './parts/SectionProjects';
import SectionSkills from './parts/SectionSkills';

import './style/main.css';

const REF_W = 1024;
const REF_F = 16;

const App = () => {
  // Resize font-size based on page width
  useEffect(() => {
    const onResize = () => {
      const page = document.getElementsByClassName('page')[0];
      if (!page) return;
      const w = page.getBoundingClientRect().width;
      const value = `calc(${REF_F}px * ${w} / ${REF_W})`;
      document.documentElement.style.setProperty('font-size', value);
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  return (
    <>
      <div
        className={classNames(
          'noise',
          'p-8 bg-background font-text font-extralight text-text',
          'max-desktop:p-0',
          'not-print:bg-linear-to-b from-background to-background-2',
          'print:p-0 print:bg-white',
        )}
      >
        {/* Web */}
        <main className="print:hidden w-full desktop:max-w-page mx-auto">
          <Page>
            <SectionSkills />
            <SectionExpPage1 />
            <SectionExpPage2 />
            <SectionExpPageRest />
            <SectionEducation />
            <SectionProjects />
          </Page>
        </main>

        {/* Print */}
        <main className="not-print:hidden w-full">
          <Page pageNb={1} totalPages={2}>
            <SectionSkills />
            <SectionExpPage1 />
          </Page>
          <Page pageNb={2} totalPages={2} withoutHeader>
            <SectionExpPage2 />
            <SectionExpPageRest />
            <SectionEducation />
            <SectionProjects />
          </Page>
        </main>
      </div>

      <Aside />
    </>
  );
};

export default App;
